export default __webpack_public_path__ + "static/media/employee_template.869843de.xlsx";